export const SHELL_CONFIG = 'SHELL_CONFIG';
export const SHELL_CONFIG_LOADING = 'SHELL_CONFIG_LOADING';
export const LOADING_DATA = 'LOADING_DATA';
export const RESET_STATE = 'RESET_STATE';
export const RESET_JIT_ORG_STATE = 'RESET_JIT_ORG_STATE';
export const SET_EXCEPTION_HANDLER = 'SET_EXCEPTION_HANDLER';
export const UNHANDLED_EXCEPTION = 'UNHANDLED_EXCEPTION';
export const RESET_SCROLL = 'RESET_SCROLL';
export const GRID_CHECK_ALL = 'GRID_CHECK_ALL';
export const RESET_EXCEPTION = 'RESET_EXCEPTION';
